












































































































import Vue from "vue";
import { Component, Watch, Emit } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { ReminderModel, RemindersClient } from "@/diamond-support-api";
import { ErrorMessage, SuccessMessage, SystemMessage } from "@/shared";
import moment from "moment";

@Component
export default class ReminderEdit extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;

  shown = true;
  loading = false;
  reminder: ReminderModel = new ReminderModel();
  remindersApi = new RemindersClient();

  search = "";

  dueOnDate = "";
  dueOnTime = "";
  dueOnTimeMenu = false;
  dueOnDateMenu = false;

  rules = {
    required: [(value: any) => !!value || "Required."],
  };

  async mounted() {
    if (this.$route.params.id) {
      this.reminder = await this.remindersApi.get(this.$route.params.id);
      if (this.reminder.dueOnUtc) {
        this.dueOnDate = moment(this.reminder.dueOnUtc).format("YYYY-MM-DD");
        this.dueOnTime = moment(this.reminder.dueOnUtc).format("HH:mm");
      }
    }
  }

  async save() {
    if (this.$route.params.id) {
      this.reminder.dueOnUtc = moment
        .utc(new Date(`${this.dueOnDate} ${this.dueOnTime}`))
        .toDate();
      if (this.reminder.dueOnUtc < new Date()) {
        this.showMessage(
          new ErrorMessage(`Due On Time must be the futrue time`)
        );
      } else if (!this.dueOnTime) {
        this.showMessage(new ErrorMessage(`Due On Time must be selected `));
      } else {
      this.loading = true;
      await this.remindersApi
        .put(this.reminder)
        .then((response) => {
          if (response !== null) this.emitUpdated(response);
          this.showMessage(new SuccessMessage(`Reminder has been updated.`));
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    }
    this.shown = false;
  }

  @Emit("itemUpdated")
  emitUpdated(item: ReminderModel) {
    return item;
  }

  @Watch("dueOnDate")
  onDueOnDateChanged(val: string | null, oldVal: string | null) {
    if (val && !oldVal) return;
    if (val != oldVal) this.dueOnTime = "";
  }
  
  @Watch("shown")
  onShownChanged() {
    if (!this.shown) {
      if (this.$route.path.includes("urgentReminderList")) {
        this.$router.push(`/userDashboard/urgentReminderList`);
      } else {
        this.$router.push(`/userDashboard`);
      }
    }
  }
}
